import React, { FC } from 'react';
import { Card, Column, Row, Spacer, } from '@components/1-atoms';

import { View } from 'react-native';
import Text from '@components/1-atoms/Text';
import ListItem from '@components/2-molecules/ListItem';

import useTheme from '@lib/theme';

import MenuIcon from '@assets/icons/plus'
import { PageProps } from '@lib/constants';

import Illustration from "@assets/contact-illustration";


const theme = useTheme();
const icon = /* null; // */ <MenuIcon />;


type Props = Omit<PageProps, 'data'> & {};

const WidgetCreateContact: FC<Props> = ({ navigation, ...props }) => {

    return (

        <Card
            title='Create a contact'
            themed={false}
        /* icon={icon} onAction={ () => {} } */
        >
            
            <View>
                <Spacer h={3} />
                {/* Illustration */}
                <Row style={{ justifyContent: 'flex-start' }}>
                    <Illustration />
                </Row>
                <Spacer h={.9} />

                {/* Description */}
                <Row>
                    <Column>
                        <Text {...props}>Add your customers and suppliers contact information, and track your businesses with them.</Text>
                    </Column>
                </Row>
                <Spacer h={3} />

            </View>

            {/* Create a contact */}
            <View>
                <ListItem inset onPress={() => navigation?.navigate('ContactCreate')}>
                <Text color={theme.pallete.accentColor}>Create a contact</Text>
                </ListItem>
            </View>

        </Card>
    );
};

export default WidgetCreateContact;